import React, { PropsWithChildren } from "react";
import { useAppSelector } from "store/hooks";
import { userSettingState } from "store/selectors";
import { twMerge } from "tailwind-merge";

export function WidgetContainer({
  classes = "",
  children,
}: PropsWithChildren<{ classes?: string }>) {
  const { isDarkMode } = useAppSelector(userSettingState);
  return (
    <div
      className={twMerge(
        `w-full relative h-full border border-gray-200 ${
          isDarkMode ? "bg-darkSilver" : "bg-white"
        } rounded-md p-2 md:p-4 ${classes}`
      )}
    >
      {children}
    </div>
  );
}
